import React, { Component } from 'react';
import classnames from 'classnames';
import styles from './filterItem.module.scss';

export default function FilterItem({
  label,
  className,
  style = {},
  children = null,
}) {
  return (
    <div className={classnames(styles.filterItem, className)} style={style}>
      <div className={styles.header}>
        {label}
        {label && ':'}
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
}
